import type { Brand } from "@tento-ui/brand/brand";
import type { PricingSection } from "@tento-ui/brand/@generated/models";
import {
  createLandingPageFactory,
  createLandingSectionFactories,
} from "@tento-ui/brand/landing/landing-section-factories";
import { PresentationAssetRegistry } from "@tento-ui/components/presentation/presentation-asset-registry";
import { PlanSelector } from "@tento-ui/brand/plan-selector/plan-selector";
import { PublicPlanCopy } from "../plans/public-plan-copy";
import { LonaLandingDesignSystem } from "./landing-design-system";

function signupHrefForPlan(plan: PlanSelector.Plan, isYearly: boolean): string {
  const planParam = plan.id.toLowerCase();
  const billingParam = isYearly ? "annual" : "monthly";
  return `${LonaLandingDesignSystem.pricing.signupPath}?plan=${encodeURIComponent(planParam)}&billing=${billingParam}`;
}

function renderPricingContent(_section: PricingSection): HTMLElement {
  return PlanSelector.makeWith({
    plans: PublicPlanCopy.PLANS,
    activeProduct: null,
    isPromoProduct: false,
    isPaymentsTesting: false,
    prefilledPromoCode: null,
    onPlanSelect: (plan, isYearly) => {
      window.location.href = signupHrefForPlan(plan, isYearly);
    },
    onContactUs: () => {
      window.location.href = LonaLandingDesignSystem.pricing.contactHref;
    },
  }).assignStyles({
    "--plan-selector-feature-font-size": "var(--loaf-size-meta)",
  });
}

export const landingPageStyle = LonaLandingDesignSystem.style;

export const defaultSections: Brand.LandingPage["landing"]["sections"] =
  createLandingSectionFactories({
    designSystem: LonaLandingDesignSystem,
    renderPricingContent,
    presentationAssetRegistry: PresentationAssetRegistry.LANDING,
  });

export const makePageFactory = createLandingPageFactory;
